import { STATUS_CANCELLED } from 'tennders-stracture/libs/constants'
import useSession from 'tennders-auth/hooks/useSession'
import GHref from 'tennders-market/common/components/element/GHref'
import useTranslation from 'next-translate/useTranslation'
import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCircleInfo } from '@fortawesome/free-solid-svg-icons'

const AcceptedButNotAssigned = ({
  offer,
  transaction,
  assignOffer,
  acceptOffer,
  declineOffer,
  marketPlace
}) => {
  const { isBroker } = useSession()
  const isOwner = () => (marketPlace ? transaction?.isSharedWithMarketPlace : isBroker())
  const [submitting, setSubmitting] = useState(false)
  const { t } = useTranslation()

  if (offer?.status?.label === 'OFFER_DECLINED') {
    return (
      <div className="w-50">
        <div className="pl-16 ml-16 border-l">
          <div className="text-10 color-mid-gray italic lh-1">{offer?.updatedAt}</div>
          <div className="bold mb-16">
            {t(`offer:${marketPlace && !transaction.marketPrice ? 'offer_has_been_declined' : 'offer_has_been_declined'}`, { user: offer?.updatedBy?.name })}
          </div>
        </div>
      </div>
    )
  }

  if (offer?.status?.label !== 'OFFER_ACCEPTED_BY_BROKER'
            && offer?.status?.label !== 'OFFER_ACCEPTED_BY_NON_BROKER') {
    return null
  }

  if (transaction?.status?.label === STATUS_CANCELLED) {
    return null
  }

  if ((offer?.status?.label === 'OFFER_ACCEPTED_BY_NON_BROKER' && !isOwner())
              || (offer?.status?.label === 'OFFER_ACCEPTED_BY_BROKER' && isOwner())) {
    return (
      <div className="w-50">
        <div className="p-16 ml-16 border-l pos-rel">

          <div className="color-green text-center">
            <div className="d-flex row align-center">
              <FontAwesomeIcon icon={faCheck} fontSize={24} className="mr-8" aria-hidden="true" />
              {' '}
              Offer Accepted by you
            </div>
          </div>
          <p className="mt-10">Waiting for counterpart to approve & assign</p>
        </div>
      </div>
    )
  }

  return (
    <div className="w-50">
      <div className="pl-16 ml-16 border-l">
        <div className="text-10 color-mid-gray italic lh-1">{offer?.updatedAt}</div>
        <div className="bold mb-16">
          Offer Accepted By
          {' '}
          {offer?.owner}
        </div>
        <div className="d-flex row align-center">
          <div className="mr-20">
            {isOwner()
              ? (
                <GHref
                  disabled={!transaction?.isOfferable || submitting}
                  onClick={async () => {
                    setSubmitting(true)
                    await assignOffer(offer)
                    setSubmitting(false)
                  }}
                  submitting={submitting}
                  className="btn-border standard-btn small"
                >
                  Assign Pair
                </GHref>
              )
              : (
                <GHref
                  disabled={!transaction?.isOfferable || submitting}
                  onClick={async () => {
                    setSubmitting(true)
                    await acceptOffer(offer)
                    setSubmitting(false)
                  }}
                  className="btn-border standard-btn small"
                >
                  Accept
                </GHref>
              )}
          </div>
          <div>
            <GHref
              disabled={!transaction?.isOfferable}
              onClick={() => declineOffer(offer)}
              className="text-underline"
            >
              Decline
            </GHref>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AcceptedButNotAssigned
